module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/service360/service360-view-activation-details/service360-view-activation-details.component.css
// module id = 988
// module chunks = 1